import { createComponent } from '../core/create-component.js';

const SellingPointsFeatures = createComponent({
    displayName: 'SellingPointsFeatures',
    root: 'ul',
    propConfig: {
        classNames: [
            'swan-selling-points-features'
        ]
    }
});

export { SellingPointsFeatures };
